"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveDescription = void 0;
const react_1 = __importStar(require("react"));
const typestyle_1 = require("typestyle");
const Colors_1 = require("../../../../Colors");
const index_1 = require("../../../DOM/index");
const Main = typestyle_1.style({
    background: Colors_1.Colors.grey[9],
    color: Colors_1.Colors.grey[3],
    padding: 10,
    fontSize: 12,
    overflowY: 'hidden',
    resize: 'none',
    border: `1px solid ${Colors_1.Colors.grey[8]}`,
    borderRadius: 4,
});
exports.ActiveDescription = ({ onChange, value, className, isLocked }) => {
    const DescriptionRef = react_1.useRef(null);
    react_1.useEffect(() => {
        if (DescriptionRef.current) {
            DescriptionRef.current.style.height = `${DescriptionRef.current.scrollHeight}px`;
        }
    }, [DescriptionRef.current]);
    if (isLocked) {
        if (!value) {
            return react_1.default.createElement(react_1.default.Fragment, null);
        }
        return (react_1.default.createElement("textarea", { disabled: true, rows: 1, "data-gramm_editor": "false", ref: DescriptionRef, className: `${Main} ${className}`, defaultValue: value }));
    }
    return (react_1.default.createElement("textarea", { rows: 1, "data-gramm_editor": "false", ref: DescriptionRef, placeholder: "Put your description here", onClick: (e) => e.stopPropagation(), onMouseMove: (e) => e.stopPropagation(), onMouseDown: (e) => {
            index_1.DOM.panLock = true;
        }, onFocus: (e) => {
            e.currentTarget.style.height = 'auto';
            e.currentTarget.style.height = e.currentTarget.scrollHeight + 'px';
            index_1.DOM.panLock = true;
        }, onBlur: () => {
            index_1.DOM.panLock = false;
            if (DescriptionRef.current) {
                onChange(DescriptionRef.current.value);
            }
        }, onInput: (e) => {
            index_1.DOM.panLock = true;
            e.currentTarget.style.height = 'auto';
            e.currentTarget.style.height = e.currentTarget.scrollHeight + 'px';
        }, className: `${Main} ${className}`, defaultValue: value }));
};
